module.exports = __webpack_public_path__ + "ab2c06193aa9f3141362b6fdbfd2856c.svg";